// Index principal pour la bibliothèque OpenCV.js localisée
// Ce fichier permet d'importer facilement OpenCV depuis le dossier local

// Import du fichier principal OpenCV
import './dist/opencv.js';

// Fonction utilitaire pour vérifier si OpenCV est initialisé
export function isOpenCVReady() {
  return typeof cv !== 'undefined' && cv.isInitialized;
}

// Promise pour attendre l'initialisation d'OpenCV
export function waitForOpenCV() {
  return new Promise((resolve) => {
    if (isOpenCVReady()) {
      resolve(cv);
    } else {
      // Utiliser cvReadyPromise si disponible (version 4.11.0+)
      if (typeof cv !== 'undefined') {
        cv.then((resolved_cv) => resolve(resolved_cv));
      } else {
        // Fallback pour les versions antérieures
        cv.onRuntimeInitialized = () => {
          resolve(cv);
        };
      }
    }
  });
}

// Export par défaut
export default {
  cv,
  isOpenCVReady,
  waitForOpenCV
}; 